/* eslint-disable no-global-assign, no-unused-vars */
/* global __webpack_public_path__ */

function resolveCurrentScript() {
  if (typeof document === 'undefined') {
    return null
  }

  if (document.currentScript) {
    return document.currentScript
  }

  const scripts = document.getElementsByTagName('script')
  return scripts.length ? scripts[scripts.length - 1] : null
}

const currentScript = resolveCurrentScript()

if (currentScript && currentScript.src) {
  const publicPath = currentScript.src
    .replace(/\/js\/[^/]+(\?.*)?$/, '/')
    .replace(/[^/]+(\?.*)?$/, '')

  __webpack_public_path__ = publicPath
}
